import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";
import { AlignmentHorizontalOption } from "@ecp-redux/dto/themeSettings/themeSettings.types";
import { BoxComplaintFormFields } from "./BoxComplaintForm.types";

export const IBoxComplaintFormMessagesScheme = z.object({
  complaint_form_title: themeScheme.MessageScheme.default(
    "Określ i opisz temat, a nasz konsultant skontaktuje się z Tobą"
  ),

  complaint_form_placeholder_name_and_surname:
    themeScheme.MessageScheme.default("Imię i nazwisko"),
  complaint_form_heading_name_and_surname:
    themeScheme.MessageScheme.default("Imię i nazwisko"),
  complaint_form_placeholder_email_or_phone:
    themeScheme.MessageScheme.default("E-mail lub telefon"),
  complaint_form_heading_email_or_phone:
    themeScheme.MessageScheme.default("E-mail lub telefon"),
  complaint_form_heading_label_purchase_date:
    themeScheme.MessageScheme.default("Data zakupu"),
  complaint_form_placeholder_product:
    themeScheme.MessageScheme.default("Produkt / usługa"),
  complaint_form_heading_product:
    themeScheme.MessageScheme.default("Produkt / usługa"),
  complaint_form_placeholder_issue_description:
    themeScheme.MessageScheme.default("Krótki opis wady"),
  complaint_form_heading_issue_description:
    themeScheme.MessageScheme.default("Krótki opis wady"),
  complaint_form_placeholder_requested_solution:
    themeScheme.MessageScheme.default("Oczekiwane rozwiązanie"),
  complaint_form_heading_requested_solution: themeScheme.MessageScheme.default(
    "Oczekiwane rozwiązanie"
  ),
  complaint_form_save_button:
    themeScheme.MessageScheme.default("Wyślij wiadomość"),
  complaint_form_information: themeScheme.MessageScheme.default(
    'Administratorem Państwa danych osobowych jest ****** z siedzibą w Warszawie.<a href="#"> Państwa</a> dane przetwarzane będą w celu: rozwiązania spraw, z którym Państwo się do nas zwracacie, prowadzenia analiz i statystyk, wypełnienia obowiązków prawnych (w stosunku do zgłoszeń dotyczących takich obowiązków) oraz w celu dochodzenia lub obrony przed roszczeniami. W związku z przetwarzaniem przez *****. Państwa danych osobowych mają Państwo prawo do: sprostowania danych; dostępu do danych; usunięcia danych; ograniczenia przetwarzania; przenoszenia danych; sprzeciwu wobec przetwarzania danych ....'
  ),
  complaint_form_empty_verification_fullName: themeScheme.MessageScheme.default(
    "Uzupełnienie pola jest wymagane"
  ),
  complaint_form_empty_verification_email_or_phone:
    themeScheme.MessageScheme.default("Uzupełnienie pola jest wymagane"),
  complaint_form_empty_verification_invoice_number:
    themeScheme.MessageScheme.default("Uzupełnienie pola jest wymagane"),
  complaint_form_empty_verification_product: themeScheme.MessageScheme.default(
    "Uzupełnienie pola jest wymagane"
  ),
  complaint_form_empty_verification_issueDescription:
    themeScheme.MessageScheme.default("Uzupełnienie pola jest wymagane"),
  complaint_form_empty_verification_requestedSolution:
    themeScheme.MessageScheme.default("Uzupełnienie pola jest wymagane"),
  complaint_form_reason_input_exceeded: themeScheme.MessageScheme.default(
    "Przekroczono maksymalną ilość znaków (50)"
  ),
  complaint_form_short_input_length_exceeded: themeScheme.MessageScheme.default(
    "Przekroczono maksymalną ilość znaków (100)"
  ),
  complaint_form_long_input_length_exceeded: themeScheme.MessageScheme.default(
    "Przekroczono maksymalną ilość znaków (500)"
  ),
  complaint_form_success: themeScheme.MessageScheme.default(
    "Formularz został wysłany"
  ),
  complaint_form_failure: themeScheme.MessageScheme.default(
    "Nie udało się wysłać formularza"
  ),

  complaint_form_heading_upload_photo: themeScheme.MessageScheme.default(
    "Zdjęcie uszkodzenia lub wady"
  ),

  complaint_form_upload_file_button:
    themeScheme.MessageScheme.default("Wybierz plik"),

  complaint_form_upload_file_delete: themeScheme.MessageScheme.default("Usuń"),

  complaint_form_upload_file_error: themeScheme.MessageScheme.default(
    "Możesz dodać max. 5 plików, w formacie: doc, pdf, jpg, png, gif, o łącznym rozmiarze do 10 MB"
  ),
  complaint_form_heading_invoice_number: themeScheme.MessageScheme.default(
    "Numer zamówienia / faktury"
  ),
  complaint_form_placeholder_invoice_number: themeScheme.MessageScheme.default(
    "Numer zamówienia / faktury"
  ),
  complaint_form_heading_purchase_date: themeScheme.MessageScheme.default(
    "Uzupełnienie pola jest wymagane"
  ),
  complaint_form_heading_solution: themeScheme.MessageScheme.default(
    "Uzupełnienie pola jest wymagane"
  ),
  complaint_form_solution_repair: themeScheme.MessageScheme.default("Naprawa"),
  complaint_form_solution_replacement:
    themeScheme.MessageScheme.default("Wymiana"),
  complaint_form_solution_refund:
    themeScheme.MessageScheme.default("Zwrot pieniędzy"),
});

export const IBoxComplaintFormSettingsScheme = z.object({
  complaint_form_button_style:
    themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  complaint_form_information_text_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  complaint_form_information_typo:
    themeScheme.TypoIdScheme.default("typo$$4").catch("typo$$4"),
  complaint_form_link_style:
    themeScheme.LinkIdScheme.default("link$$1").catch("link$$1"),
  complaint_form_link_basic_color:
    themeScheme.ColorIdScheme.default("color$$4").catch("color$$4"),
  complaint_form_success_info_typo:
    themeScheme.TypoIdScheme.default("typo$$4").catch("typo$$4"),
  complaint_form_success_info_text_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  complaint_form_background_success_color:
    themeScheme.ColorIdScheme.default("color$$13").catch("color$$13"),
  complaint_form_input_style:
    themeScheme.InputIdScheme.default("input$$2").catch("input$$2"),
  complaint_form_submit_button_width:
    themeScheme.SizeCSSScheme.default("100%").catch("100%"),
  complaint_form_elements_gap:
    themeScheme.SizeCSSScheme.default("30px").catch("30px"),
  complaint_form_title_spacing:
    themeScheme.SizeCSSScheme.default("30px").catch("30px"),
  complaint_form_terms_spacing:
    themeScheme.SizeCSSScheme.default("130px").catch("130px"),
  complaint_form_background_color:
    themeScheme.ColorIdScheme.default("color$$9").catch("color$$9"),
  complaint_form_submit_button_alignment: z
    .nativeEnum(AlignmentHorizontalOption)
    .default(AlignmentHorizontalOption.LEFT)
    .catch(AlignmentHorizontalOption.LEFT),
  complaint_form_submit_button_bottom_spacing:
    themeScheme.SizeCSSScheme.default("30px").catch("30px"),
  complaint_form_title_typo:
    themeScheme.TypoIdScheme.default("typo$$4").catch("typo$$4"),
  complaint_form_title_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),

  complaint_form_title_align: z
    .nativeEnum(AlignmentHorizontalOption)
    .default(AlignmentHorizontalOption.CENTER)
    .catch(AlignmentHorizontalOption.CENTER),

  complaint_form_background_error_color:
    themeScheme.ColorIdScheme.default("color$$12").catch("color$$12"),
  complaint_form_error_info_typo:
    themeScheme.TypoIdScheme.default("typo$$4").catch("typo$$4"),
  complaint_form_error_info_text_color:
    themeScheme.ColorIdScheme.default("color$$4").catch("color$$4"),
  complaint_form_textArea_style:
    themeScheme.InputIdScheme.default("input$$2").catch("input$$2"),

  complaint_form_heading_typography:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  complaint_form_heading_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),

  complaint_form_upload_file_gap:
    themeScheme.SizeCSSScheme.default("24px").catch("24px"),
  complaint_form_require_fields: themeScheme
    .MulitselectEnumScheme(BoxComplaintFormFields)
    .default(
      "fullName,contact,orderNumber,purchaseDate,product,issueDescription,requestedSolution"
    )
    .catch(
      "fullName,contact,orderNumber,purchaseDate,product,issueDescription,requestedSolution"
    ),
  complaint_form_hidden_fields: themeScheme
    .MulitselectEnumScheme(BoxComplaintFormFields)
    .default("")
    .catch(""),
  complaint_form_thank_you_page: themeScheme.UrlScheme.default("").catch(""),
  complaint_form_upload_file_button_style:
    themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),

  complaint_form_upload_file_name_typography:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),

  complaint_form_upload_file_name_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),

  complaint_form_upload_file_delete_typography:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  complaint_form_upload_file_delete_link_style:
    themeScheme.LinkIdScheme.default("link$$1").catch("link$$1"),
  complaint_form_dropdown_style:
    themeScheme.DropdownIdScheme.default("dropdown$$2").catch("dropdown$$2"),
});
